<div class="m-4">
  <div class="max-w-2xl mx-auto">
    <form [formGroup]="productVarianForm">
      <div>
        <!-- class="border-b border-gray-900/10 pb-12" -->
        <button (click)="nav.goToStocks()"><- Retour à la liste d'articles</button>
        <h2 class="text-base font-semibold leading-7 text-gray-900">Produit</h2>

        <div class="col-span-full">
          <div class="form-splitter">
            <span>Ajouter les informations générales</span>
          </div>
        </div>
        <app-form-error-display [form]="productVarianForm"></app-form-error-display>

        <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          <div class="col-span-full">
            <label for="product-name" class="block text-sm font-medium leading-6 text-gray-900">Nom du produit</label>
            <div class="mt-2">
              <input
                type="text"
                name="product-name"
                id="product-name"
                formControlName="name"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-stone-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div class="col-span-full">
              <label for="brand" class="block text-sm font-medium leading-6 text-gray-900">Marque</label>
              <div class="mt-2">
                <input
                  type="text"
                  name="brand"
                  id="brand"
                  formControlName="brand"
                  class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-stone-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div class="col-span-full">
                <label for="category" class="block text-sm font-medium leading-6 text-gray-900">Catégorie du produit</label>

                <app-category-tree
                  formControlName="category"
                  [categories]="dropdownListCategories"
                  (initialized)="onCategoryTreeReady()"
                ></app-category-tree>
              </div>

              <div class="col-span-full">
                <label for="properties" class="block text-sm font-medium leading-6 text-gray-900">Propriété</label>
                <div class="mt-2">
                  <ng-multiselect-dropdown
                    formControlName="properties"
                    [settings]="dropdownSettings"
                    [data]="dropdownListProperties"
                  ></ng-multiselect-dropdown>
                </div>
              </div>

              <div class="col-span-full">
                <label for="compositions" class="block text-sm font-medium leading-6 text-gray-900">Matériel</label>
                <div class="mt-2">
                  <ng-multiselect-dropdown
                    formControlName="compositions"
                    [settings]="dropdownSettings"
                    [data]="dropdownListMaterial"
                  ></ng-multiselect-dropdown>
                </div>
              </div>

              <div class="col-span-full">
                <label for="linings" class="block text-sm font-medium leading-6 text-gray-900">Doublure</label>
                <div class="mt-2">
                  <ng-multiselect-dropdown
                    formControlName="linings"
                    [settings]="dropdownSettings"
                    [data]="dropdownListLinings"
                  ></ng-multiselect-dropdown>
                </div>
              </div>

              <div class="col-span-full">
                <label for="description" class="block text-sm font-medium leading-6 text-gray-900">Description</label>
                <div class="mt-2">
                  <textarea
                    id="description"
                    name="description"
                    rows="3"
                    formControlName="description"
                    class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-stone-600 sm:text-sm sm:leading-6"
                  ></textarea>
                </div>
              </div>

              <div class="col-span-full">
                <div class="form-splitter">
                  <span>Ajouter une variante du produit</span>
                </div>
              </div>

              <div class="col-span-full">
                <div formArrayName="variants">
                  @for ( variant of variants.controls; track $index) {
                    <div [formGroupName]="$index" class="col-span-full border p-4 rounded-lg mt-6 relative">
                      <app-image-upload
                        [multiple]="true"
                        [maxSizeMB]="10"
                        [formControl]="getPhotoControl($index)"
                        [initialUrls]="getPhotoControl($index).value"
                      ></app-image-upload>

                      <label class="block text-sm font-medium leading-6 text-gray-900 mt-4">Color</label>
                      <div class="flex flex-wrap gap-4">
                        @for(color of backendListColors; track color.id) {
                          <label
                            class="relative w-12 h-12 rounded-full cursor-pointer border-2 transition-all duration-200"
                    [ngStyle]="{
                      'background-color': '#' + color.value,
                      'border-color': darkenColor(color.value),
                      filter:
                        variants.at($index).get('color')?.getRawValue() !== color.id
                          ? 'grayscale(50%) brightness(90%)'
                          : 'none',
                      opacity: variants.at($index).get('color')?.getRawValue() !== color.id ? '0.5' : '1'
                    }"
                            >
                            <input
                              type="radio"
                              class="sr-only"
                              [value]="color.id"
                              [formControl]="getColorControl($index)"
                              [ngClass]="{ loading: product.isLoading }"
                              />
                            </label>
                          }
                        </div>

                        @if (!variants.at($index).get('isNew')?.value) {
                          <p class="text-sm text-orange-600 mt-2">
                            La couleur ne peut pas être modifiée pour cette variante existante.
                          </p>
                        }
                        <label class="block text-sm font-medium leading-6 text-gray-900 mt-4">Sizes & Quantities</label>

                        <div formGroupName="sizes" class="grid grid-cols-2 gap-4">
                          @for (size of backendListSizes; track size.id) {
                            <div class="flex items-center gap-2">
                              <span class="w-48">{{ size.name }}</span>
                              <input
                                type="number"
                                [min]="variant.get('initialQuantities')?.value?.[size.id] ?? 0"
                                [formControlName]="size.id"
                                class="block w-full max-w-[100px] rounded-md border px-2 py-1 text-sm"
                                placeholder="0"
                                />
                              </div>
                            }
                          </div>

                          @if (!variants.at($index).get('isNew')?.value) {
                            <p class="text-sm text-orange-600 mt-2">
                              Les quantitées peuvent uniquement être augmenté pour cette variante existante.
                            </p>
                          }

                          @if ($index > 0 && (!isUpdateOfProduct || variant.get('isNew')?.value)) {
                            <button
                              type="button"
                              (click)="removeVariant($index)"
                              class="absolute top-2 right-2 text-red-500 hover:text-red-700 p-1 rounded-full"
                              title="Supprimer cette variante"
                              >
                              <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">
                                <path
                                  fill-rule="evenodd"
                                  d="M6 8a1 1 0 012 0v5a1 1 0 11-2 0V8zm4 0a1 1 0 112 0v5a1 1 0 11-2 0V8z"
                                  clip-rule="evenodd"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    d="M4 3a1 1 0 011-1h10a1 1 0 011 1v1H4V3zm1 3h10l-.867 9.03A2 2 0 0112.138 17H7.862a2 2 0 01-1.995-1.97L5 6z"
                                    clip-rule="evenodd"
                                    />
                                  </svg>
                                </button>
                              }
                            </div>
                          }
                        </div>

                        <button
                          type="button"
                          (click)="addVariant()"
                          class="mt-6 text-white inline-flex items-center rounded-md bg-stone-500 px-3 py-2 hover:bg-stone-600 focus:outline-none focus:ring-2 focus:ring-stone-600"
                          >
                          + Ajouter une variante
                        </button>
                      </div>

                      <div class="sm:col-span-2 sm:col-start-1">
                        <label for="old_price" class="block text-sm font-medium leading-6 text-gray-900">Prix initial</label>
                        <div class="mt-2">
                          <input
                            type="old_price"
                            name="old_price"
                            id="old_price"
                            formControlName="old_price"
                            class="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-stone-600 sm:text-sm sm:leading-6"
                            />
                          </div>
                        </div>

                        <div class="sm:col-span-2">
                          <label for="sale" class="block text-sm font-medium leading-6 text-gray-900">
                            Rabais appliqué sur Vestra
                          </label>
                          <div class="mt-2">
                            <select
                              id="sale"
                              name="sale"
                              formControlName="sale"
                              class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-stone-600 sm:max-w-xs sm:text-sm sm:leading-6"
                              >
                              @for (v of salesValues; track v.name) {
                                <option value="{{ v.value }}">{{ v.name }}</option>
                              }
                            </select>
                          </div>
                        </div>

                        <div class="sm:col-span-2">
                          <label class="block text-sm font-medium leading-6 text-gray-900">Prix sur Vestra</label>
                          <div class="mt-2">
                            <p>
                              {{
                              productVarianForm.value['old_price'] -
                              productVarianForm.value['old_price'] * productVarianForm.value['sale']
                              }}
                              CHF
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="col-span-full">
                        <label for="duration" class="block text-sm font-medium leading-6 text-gray-900">
                          Durée de l'offre sur Vestra
                        </label>
                        <div class="mt-2">
                          <select
                            id="duration"
                            name="duration"
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-stone-600 sm:max-w-xs sm:text-sm sm:leading-6"
                            >
                            <option>1 mois</option>
                            <option>2 mois</option>
                            <option>3 mois</option>
                            <option>4 mois</option>
                            <option>5 mois</option>
                            <option>6 mois</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <button
                      type="button"
                      (click)="saveChanges()"
                      class="mt-8 text-white inline-flex items-center rounded-md bg-stone-600 p-2 hover:bg-stone-700 focus:outline-none focus:ring-2 focus:ring-stone-600 focus:ring-offset-2 focus:ring-offset-gray-50"
                      aria-haspopup="listbox"
                      aria-expanded="true"
                      aria-labelledby="listbox-label"
                      >
                      @if (!isUpdateOfProduct) {
                        <span>Ajouter le produit sur Vestra</span>
                      } @else {
                        Modifier le produit sur Vestra
                      }
                    </button>
                  </form>
                </div>
              </div>
